import styles from "../../../styles/LandingPage/Patients.module.scss"
import navBarStyles from "../../../styles/LandingPage/NavBar.module.scss"
import * as Scroll from "react-scroll"
import classNames from "classnames"
import Link from "next/link"
import { SwipeableDrawer } from "@mui/material"

import { usePathname } from "next/navigation"
import Image from "next/image"
import StyledText from "../../typography/typography-component"
import { Routes, useTypedRouter } from "../../data/routes"
import { useTranslations } from "next-intl"
import { TrackedActions } from "../../tracking/trackedActions"

const SkinuvitaDrawer = ({
  drawerOpen,
  setDrawerOpen,
}: {
  drawerOpen: boolean
  setDrawerOpen: (drOpen: boolean) => void
}) => {
  const t = useTranslations("index")
  const pathname = usePathname()
  const scroll = Scroll.animateScroll
  const router = useTypedRouter()
  const currentLocale = router.locale || "de"
  const newLocale = currentLocale === "de" ? "en" : "de"

  return (
    <SwipeableDrawer
      className={styles.drawer}
      anchor={"right"}
      open={drawerOpen}
      onClose={() => setDrawerOpen(false)}
      onOpen={() => setDrawerOpen(true)}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "flex-start",
          height: "100%", // backgroundColor: "rgba(255, 255, 255, 0.56)",
        }}
        className={styles.col}
      >
        <div className={styles.drawerTopBar}>
          <Image
            onClick={() => {
              scroll.scrollToTop()
              setDrawerOpen(false)
            }}
            src={"/svg/skinuvita_cube.svg"}
            width={24}
            height={24}
            alt={"skinuvita logo"}
            style={{
              cursor: "pointer",
              maxWidth: "100%",
              height: "auto",
            }}
          />

          <Image
            onClick={() => setDrawerOpen(false)}
            src={"/svg/close.svg"}
            width={24}
            height={24}
            alt={"close"}
            style={{
              cursor: "pointer",
              maxWidth: "100%",
              height: "auto",
            }}
          />
        </div>
        <nav style={{ width: "100%" }}>
          <ul
            style={{
              listStyle: "none",
              paddingLeft: "0",
              margin: "0",
            }}
          >
            <Link className={classNames(navBarStyles.drawerMenuLinks, navBarStyles.link)} href={Routes.ratgeber}>
              <li className={styles.listItem}>
                <StyledText variant={"unset"}>{t("nav.guide")}</StyledText>
              </li>
            </Link>{" "}
            <a
              className={classNames(navBarStyles.drawerMenuLinks, navBarStyles.link)}
              onClick={() => void TrackedActions.goToSelfCheck()}
            >
              <li className={styles.listItem}>
                <StyledText variant={"unset"}>{t("nav.selfCheck")}</StyledText>
              </li>
            </a>
            <Link
              className={classNames(navBarStyles.drawerMenuLinks, navBarStyles.link)}
              href={Routes.aboutUs}
              onClick={() => setDrawerOpen(false)}
            >
              <li className={styles.listItem}>
                <StyledText variant={"unset"}>{t("nav.aboutUs")}</StyledText>
              </li>
            </Link>
            <Link
              className={classNames(navBarStyles.drawerMenuLinks, navBarStyles.link)}
              href={Routes.team}
              onClick={() => setDrawerOpen(false)}
            >
              <li className={styles.listItem}>
                <StyledText variant={"unset"}>{t("nav.team")}</StyledText>
              </li>
            </Link>
            <li className={styles.listItem}>
              <Scroll.Link
                onClick={() => setDrawerOpen(false)}
                className={classNames(navBarStyles.drawerMenuLinks, navBarStyles.link)}
                activeClass={styles.active}
                spy
                smooth
                offset={-100}
                delay={1}
                duration={500}
                to={"contact"}
              >
                <StyledText variant={"unset"}>{t("nav.contact")}</StyledText>
              </Scroll.Link>
            </li>
            <li className={styles.listItem}>
              {
                <Link
                  className={classNames(navBarStyles.drawerMenuLinks, navBarStyles.link)}
                  href={router.asPath}
                  locale={newLocale}
                  onClick={() => setDrawerOpen(false)}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <StyledText variant={"unset"}>{currentLocale == "de" ? "English" : "Deutsch"}</StyledText>
                    <img alt={"Pfeil"} src={"/svg/arrow_long.svg"} />
                  </div>
                </Link>
              }
            </li>
            <li className={styles.listItem}>
              {
                <Link
                  className={classNames(navBarStyles.drawerMenuLinks, navBarStyles.link)}
                  href={pathname == Routes.doctors ? Routes.home : Routes.doctors}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <StyledText variant={"unset"}>
                      {pathname == "/doctors" ? t("nav.forPatients") : t("nav.forDoctors")}
                    </StyledText>
                    <img alt={"Pfeil"} src={"/svg/arrow_long.svg"} />
                  </div>
                </Link>
              }
            </li>
          </ul>
        </nav>
      </div>
    </SwipeableDrawer>
  )
}

export default SkinuvitaDrawer
